import React from 'react';
import './Reading.css';
import atomicHabits from '../images/atomicHabits.jpg';
import richDadPoorDad from '../images/richDadPoorDad.jpg';
import alchemist from '../images/alchemist.jpg';
import eatThatFrog from '../images/eatThatFrog.jpg';
import darkTower from '../images/darkTower.jpg';
import gunahonKaDevta from '../images/gunahonKaDevta.jpg';
import sevenHabits from '../images/sevenHabits.jpg';
import mindset from '../images/mindset.jpg';
import kiteRunner from '../images/kiteRunner.jpg';
import eleanorOliphant from '../images/eleanorOliphant.jpg';
import cantHurtMe from '../images/cantHurtMe.jpg';
import sapiens from '../images/sapiens.jpg';
import raagDarbari from '../images/raagDarbari.jpeg';
import godaan from '../images/godaan.jpg';
import deepWork from '../images/deepWork.jpg';

const books = [
  {
  title: "The Dark Tower Series (Roland Deschain)",
  author: "Stephen King",
  imgSrc: darkTower,
  description: "An epic blend of fantasy, western, and horror following Roland’s relentless quest toward the Dark Tower.",
},
{
  title: "Gunahon Ka Devta",
  author: "Dharamvir Bharati",
  imgSrc: gunahonKaDevta,
  description: "A deeply emotional Hindi classic exploring love, sacrifice, and the complexities of human relationships.",
},
{
  title: "The 7 Habits of Highly Effective People",
  author: "Stephen R. Covey",
  imgSrc: sevenHabits,
  description: "A powerful framework for personal and professional effectiveness built on timeless principles.",
},
{
  title: "Mindset",
  author: "Carol S. Dweck",
  imgSrc: mindset,
  description: "Explains the difference between fixed and growth mindsets and how it shapes success.",
},
  {
    title: "Atomic Habits",
    author: "James Clear",
    imgSrc: atomicHabits,
    description: "A practical guide to building good habits and breaking bad ones.",
  },
  {
    title: "Rich Dad Poor Dad",
    author: "Robert Kiyosaki",
    imgSrc: richDadPoorDad,
    description: "An eye-opener on wealth, assets, and financial literacy.",
  },
  {
    title: "The Alchemist",
    author: "Paulo Coelho",
    imgSrc: alchemist,
    description: "A magical journey of following one's dreams.",
  },
  {
    title: "Eat That Frog",
    author: "Brian Tracy",
    imgSrc: eatThatFrog,
    description: "A motivational book on overcoming procrastination.",
  },
{
  title: "The Kite Runner",
  author: "Khaled Hosseini",
  imgSrc: kiteRunner,
  description: "A gripping story of friendship, betrayal, and redemption set against Afghanistan’s changing landscape.",
},
{
  title: "Eleanor Oliphant Is Completely Fine",
  author: "Gail Honeyman",
  imgSrc: eleanorOliphant,
  description: "A touching and slightly dark story about loneliness, healing, and human connection.",
},
{
  title: "Can't Hurt Me",
  author: "David Goggins",
  imgSrc: cantHurtMe,
  description: "A raw and intense memoir about mental toughness and pushing beyond perceived limits.",
},
{
  title: "Sapiens",
  author: "Yuval Noah Harari",
  imgSrc: sapiens,
  description: "A fascinating exploration of human history, evolution, and the forces that shaped modern society.",
},
{
  title: "Raag Darbari",
  author: "Shrilal Shukla",
  imgSrc: raagDarbari,
  description: "A sharp and satirical Hindi novel that critiques rural politics and social structures.",
},
{
  title: "Godaan",
  author: "Munshi Premchand",
  imgSrc: godaan,
  description: "A timeless Hindi classic depicting the struggles of rural India and the harsh realities of poverty.",
},
{
  title: "Deep Work",
  author: "Cal Newport",
  imgSrc: deepWork,
  description: "Focuses on the value of deep, distraction-free work in achieving meaningful success.",
}
];

const Reading: React.FC = () => {
  return (
    <div className="reading-container">
      <h2 className="reading-title">Books That Shaped My Journey</h2>
      <p className="reading-intro">These books have influenced my perspectives, motivation, and self-growth.</p>
      <div className="books-grid">
        {books.map((book, index) => (
          <div key={index} className="book-card" style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}>
            <img src={book.imgSrc} alt={book.title} className="book-cover" />
            <div className="book-info">
              <h3 className="book-title">{book.title}</h3>
              <h4 className="book-author">{book.author}</h4>
              <p className="book-description">{book.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reading;
